var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticStyle: { "font-size": "18px" } }, [
      _vm._v("招商流失月度对比")
    ]),
    _c("div", {
      ref: "statusEchart",
      staticStyle: { "min-width": "40vw", "min-height": "40vh" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }